import React, { useState } from "react";
import { menuData } from "../Menu/MenuData";
import Background from "../../Assets/Ostalo/bg.jpg";
import { motion, AnimatePresence } from "framer-motion"; // Importamo motion alate

const HomeMain = () => {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(0); // 1 za desno, -1 za lijevo

  const nextDay = () => {
    setDirection(1);
    setIndex((prev) => (prev + 1) % menuData.length);
  };

  const prevDay = () => {
    setDirection(-1);
    setIndex((prev) => (prev - 1 + menuData.length) % menuData.length);
  };

  // Varijante za slider jela
  const sliderVariants = {
    enter: (direction) => ({
      x: direction > 0 ? 100 : -100,
      opacity: 0,
    }),
    center: {
      x: 0,
      opacity: 1,
      transition: { duration: 0.4 },
    },
    exit: (direction) => ({
      x: direction < 0 ? 100 : -100,
      opacity: 0,
      transition: { duration: 0.3 },
    }),
  };

  return (
    <div className="home-main">
      <img className="bg-image" src={Background} alt="Pozadina" />
      <div className="overlay"></div>

      <div className="content">
        {/* Logo lagano pada odozgo */}
        <motion.div
          className="main-logo"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          Logo
        </motion.div>

        {/* Info box ulazi s lijeve strane */}
        <motion.div
          className="info-box"
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          <h5>Radno vrijeme:</h5>
          <p>
            <i className="fi fi-bs-clock"></i> 09:00 - 23:00
          </p>
          <a href="/" target="_blank" rel="noreferrer">
            <i className="fi fi-bs-marker"></i> Samoborska cesta
          </a>
        </motion.div>

        {/* Slider sekcija */}
        <div className="menu-slider">
          <button onClick={prevDay}>
            <i className="fi fi-bs-angle-small-left"></i>
          </button>

          <div
            className="menu-item-container"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <AnimatePresence custom={direction} mode="wait">
              <motion.div
                key={index}
                custom={direction}
                variants={sliderVariants}
                initial="enter"
                animate="center"
                exit="exit"
                className="menu-item"
              >
                <h3>{menuData[index].dan}</h3>
                <span>{menuData[index].date}</span>
                <h4>{menuData[index].jelo}</h4>
                <p>{menuData[index].dodaci}</p>
                <div className="price">{menuData[index].price}</div>
              </motion.div>
            </AnimatePresence>
          </div>

          <button onClick={nextDay}>
            <i className="fi fi-bs-angle-small-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomeMain;
